/* eslint-disable import/prefer-default-export */
import axios from '../axios';

// =============================================================================
// Service de HR — apenas o que a Tela 1 de Roteirização consome.
//
// O EmployeeNameSearch já tem seu próprio fetch interno (GET /hr/employees);
// este service serve apenas o select de departamentos no filtro.
// =============================================================================

// ─── Lista de departamentos (1 fetch no mount da tela) ─────────
export async function getDepartments() {
   const response = await axios.get('/hr/departments');

   // Padrão JSend: data.departments. Defensivo — se backend variar
   // (alguns controllers usam chave singular), tenta os fallbacks comuns.
   return (
      response?.data?.data?.departments ??
      response?.data?.data?.employeeDepartments ??
      []
   );
}

// ─── Catálogo de cargos (GET /hr/job-positions) ────────────────
// Reusado pelo cadastro de funcionário e pelos seletores de "cargo pretendido"
// / "vaga" do submódulo de Recrutamento. Cada item: { id, position_name }.
export async function listJobPositions() {
   const response = await axios.get('/hr/job-positions');
   return response?.data?.data?.job_positions ?? [];
}

// ─── Catálogo de centros de custo (GET /hr/cost-centers) ───────
// Cada item: { id, cost_center_code, cost_center_name }. Mesmo recurso que o
// EmployeeForm consome; extraído p/ o pré-cadastro do onboarding (Fase 1).
export async function listCostCenters() {
   const response = await axios.get('/hr/cost-centers');
   return response?.data?.data?.cost_centers ?? [];
}
